import { addOption, addCheckbox } from './patterns/dynamic-html';
import { sortAsc } from './patterns/sort-util';
import { dropdownEndpoint } from './patterns/endpoints';
import { handlePastCongressFilters } from './populate-congress';

window.addEventListener('load', () => {
    if (document.querySelector('.congresses--past') || document.querySelector('.congress--upcoming')) {
        fetch(dropdownEndpoint)
            .then((response) => { return response.json(); })
            .then((data) => {
                const categoryValues = data.data.values.filter((v) => {
                    return v.type === 'Category';
                });

                if (window.location.pathname.includes('scientific-congresses')) {
                    addCheckbox('categoryPast', sortAsc(categoryValues, 'name'), handlePastCongressFilters);
                } else {
                    addOption('categoryPast', sortAsc(categoryValues, 'name'), 'name');
                }
            });
    }

    if (document.querySelector('.publications') || document.querySelector('.other-publications')) {
        fetch(dropdownEndpoint)
            .then((response) => { return response.json(); })
            .then((data) => {
                const categoryValues = data.data.values.filter((v) => {
                    return v.type === 'Category';
                });

                addOption('categoryPublication', sortAsc(categoryValues, 'name'), 'name');
            });
    }
});
